import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from 'vue';
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui';
import FileWrapperMultiViewPdf from './FileWrapperMultiViewPdf.vue';
import _ from 'lodash';
import PtNodata from '../PtNodata';
import { Icon as PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/DropdownClose.svg';
import '@patsnap-ui/icon/assets/solid/DropdownOpen.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'FileWrapperMultiViewModify',
  props: {
    list: {
        type: Array,
        default: () => [],
    },
    round: {
        type: Number,
        default: 1,
    },
    mrdt: {
        type: String,
        default: '',
    },
},
  emits: ['onChange'],
  setup(__props, { emit: emits }) {

const props = __props

const isShowDropDown = ref(false);




const currentSelectModifyFile = ref(_.get(props.list, 0));

const onSelect = (item) => {
    currentSelectModifyFile.value = item;
};

const hasSwitch = ref(false);
const modifyFileType = ref('text');
const nodata = ref(false);

watch(currentSelectModifyFile, () => {
    hasSwitch.value = false;
    nodata.value = false;
    if (currentSelectModifyFile.value.pdf && currentSelectModifyFile.value.text) {
        hasSwitch.value = true;
        // modifyFileType.value = 'text';
    } else if (!currentSelectModifyFile.value.pdf && !currentSelectModifyFile.value.text) {
        nodata.value = true;
    } else {
        modifyFileType.value = currentSelectModifyFile.value.text ? 'text' : 'pdf';
    }
}, { immediate: true });

const showTextFile = computed(() => {
    return modifyFileType.value === 'text';
});

const showPdfFile = computed(() => {
    return modifyFileType.value === 'pdf';
});

const modifyFileTips = computed(() => {
    return modifyFileTips;
});

watch(currentSelectModifyFile, () => {
    const mrdt = _.get(currentSelectModifyFile.value, 'mrdt');
    emits('onChange', mrdt);
}, { immediate: true });

// 获取默认选中
watch(() => props.mrdt, (val) => {
    const item = _.find(props.list, { mrdt: val });
    if (item) {
        currentSelectModifyFile.value = item;
    } else {
        currentSelectModifyFile.value = _.head(props.list);
    }
}, { immediate: true });


return { __sfc: true,isShowDropDown, props, emits, currentSelectModifyFile, onSelect, hasSwitch, modifyFileType, nodata, showTextFile, showPdfFile, modifyFileTips, Dropdown, DropdownMenu, DropdownItem, FileWrapperMultiViewPdf, PtNodata, PtIcon }
}

})